module.exports = __webpack_public_path__ + "guest-icon.png?b09008a0387953fdbc3ddd3fe2714f31";